/**
 * Created by Jonas Wålekvist on 2018-02-22.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {AssetLoaderEvent} from "@nolimitcity/slot-game/bin/core/resource/asset/AssetLoaderEvent";
import {LoaderEvent} from "@nolimitcity/slot-game/bin/core/resource/event/LoaderEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DungeonQuestGameAssets} from "../game/DungeonQuestGameAssets";

export class ColorEffectTextureCache {

    public static SUFFIX_WHITE:string = "_white";
    public static SUFFIX_DESATURATED:string = "_desat";

    private readonly _whiteTextureIds:string[];
    private readonly _desaturatedTextureIds:{ textureId:string, amount:number }[];
    private _missingResourceTexture:PIXI.Texture;

    constructor() {
        this._whiteTextureIds = [];
        this._desaturatedTextureIds = [];
        EventHandler.addEventListener(this, AssetLoaderEvent.LEVEL_COMPLETE, (event:AssetLoaderEvent) => this.onAssetLevelComplete(event));
        EventHandler.addEventListener(this, LoaderEvent.RESOURCES_LOADED, (event:LoaderEvent) => this.onResourcesLoaded(event));
    }

    private onResourcesLoaded(event:LoaderEvent) {
        if(event.key == ResourcesGroupName.INTRO) {
            this._missingResourceTexture = GameResources.getTextures("missingResource")[0];
        }
        if(event.key == ResourcesGroupName.MAIN) {
            this.preCacheTextures();
        }
    }

    private preCacheTextures():void {

        const whiteAndDesat:PIXI.Texture[] = [
            DungeonQuestGameAssets.getSymbolStateTextures("L1")[0],
            DungeonQuestGameAssets.getSymbolStateTextures("L2")[0],
            DungeonQuestGameAssets.getSymbolStateTextures("L3")[0],
            DungeonQuestGameAssets.getSymbolStateTextures("L4")[0],
            DungeonQuestGameAssets.getSymbolStateTextures("M1")[0],
            DungeonQuestGameAssets.getSymbolStateTextures("M2")[0],
            DungeonQuestGameAssets.getSymbolStateTextures("M3")[0],
            DungeonQuestGameAssets.getSymbolStateTextures("M4")[0],
            DungeonQuestGameAssets.getSymbolStateTextures("S")[0],
            DungeonQuestGameAssets.getSymbolStateTextures("W")[0]
        ];

        let white:PIXI.Texture[] = [
            GameResources.getTextures(DungeonQuestGameAssets.getTransformIntroGfxName("L1"))[0],
            GameResources.getTextures(DungeonQuestGameAssets.getTransformIntroGfxName("L2"))[0],
            GameResources.getTextures(DungeonQuestGameAssets.getTransformIntroGfxName("L3"))[0],
            GameResources.getTextures(DungeonQuestGameAssets.getTransformIntroGfxName("L4"))[0],
            GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_COLOSSAL_STILL)[0]
        ];

        for(let texture of whiteAndDesat) {
            this.getDesaturatedTexture(texture, 0.5);
        }

        white = white.concat(whiteAndDesat);

        for(let texture of white) {
            this.getWhiteTexture(texture);
        }


    }

    private updateAllCachedTexture() {
        Logger.logDev("ColorEffectTextureCache:updateAllCachedTexture");
        for(let data of this._desaturatedTextureIds) {
            Logger.logDev("ColorEffectTextureCache: Updating desaturated version of: " + data.textureId);
            ColorEffectTextureCache.createDesaturatedTexture(PIXI.utils.TextureCache[data.textureId], data.amount);
        }
        for(let id of this._whiteTextureIds) {
            Logger.logDev("ColorEffectTextureCache: Updating white version of: " + id);
            ColorEffectTextureCache.createWhiteTexture(PIXI.utils.TextureCache[id]);
        }
    }

    private onAssetLevelComplete(event:AssetLoaderEvent) {
        if(event.name == ResourcesGroupName.MAIN && event.level > 1) {
            this.updateAllCachedTexture();
        }
    }

    public getDesaturatedTexture(sourceTexture:PIXI.Texture, desaturateAmount:number):PIXI.Texture {
        let texture = GameResources.getTextures(sourceTexture.textureCacheIds[0] + ColorEffectTextureCache.SUFFIX_DESATURATED + desaturateAmount)[0];

        if(texture != this._missingResourceTexture) {
            return texture;
        } else {

            Logger.logDev("ColorEffectTextureCache: No desaturated in cache. Creating new desaturated version for: " + sourceTexture.textureCacheIds[0]);
            ColorEffectTextureCache.createDesaturatedTexture(sourceTexture, desaturateAmount);
            this._desaturatedTextureIds.push({
                textureId : sourceTexture.textureCacheIds[0],
                amount : desaturateAmount
            });
            return this.getDesaturatedTexture(sourceTexture, desaturateAmount);
        }
        /*


                try {
                    return GameResources.getTextures(sourceTexture.textureCacheIds[0] + ColorEffectTextureCache.SUFFIX_DESATURATED + desaturateAmount)[0];
                } catch {
                    Logger.logDev("No desaturated in cache. Creating new desaturated version for: " + sourceTexture.textureCacheIds[0]);
                    ColorEffectTextureCache.createDesaturatedTexture(sourceTexture, desaturateAmount);
                    this._desaturatedTextureIds.push({
                        textureId : sourceTexture.textureCacheIds[0],
                        amount : desaturateAmount
                    });
                    return this.getDesaturatedTexture(sourceTexture, desaturateAmount);
                }*/
    }

    public getWhiteTexture(sourceTexture:PIXI.Texture):PIXI.Texture {

        let texture = GameResources.getTextures(sourceTexture.textureCacheIds[0] + ColorEffectTextureCache.SUFFIX_WHITE)[0];

        if(texture != this._missingResourceTexture) {
            return texture;
        } else {
            Logger.logDev("ColorEffectTextureCache: No White out in cache. Creating new white version for: " + sourceTexture.textureCacheIds[0]);
            ColorEffectTextureCache.createWhiteTexture(sourceTexture);
            this._whiteTextureIds.push(sourceTexture.textureCacheIds[0]);
            return this.getWhiteTexture(sourceTexture);
        }

        /* try {
             return GameResources.getTextures(sourceTexture.textureCacheIds[0] + ColorEffectTextureCache.SUFFIX_WHITE)[0];
         } catch {
             Logger.logDev("No White out in cache. Creating new white version for: " + sourceTexture.textureCacheIds[0]);
             ColorEffectTextureCache.createWhiteTexture(sourceTexture);
             this._whiteTextureIds.push(sourceTexture.textureCacheIds[0]);
             return this.getWhiteTexture(sourceTexture);
         }*/
    }

    private static createWhiteTexture(sourceTexture:PIXI.Texture) {
        const sprite = new PIXI.Sprite(sourceTexture);
        const colorMatrixFilter = new PIXI.filters.ColorMatrixFilter();
        const lightness:number = 1.0;
        const colorValue = 1.0;
        colorMatrixFilter.matrix = [
            colorValue, 0.0, 0.0, 0.0, lightness,
            0.0, colorValue, 0.0, 0.0, lightness,
            0.0, 0.0, colorValue, 0.0, lightness,
            0.0, 0.0, 0.0, colorValue, 0];

        sprite.filters = [colorMatrixFilter];
        const renderTexture:PIXI.RenderTexture = PIXI.RenderTexture.create({
            width : sourceTexture.width,
            height : sourceTexture.height,
            scaleMode : sourceTexture.baseTexture.scaleMode,
            resolution : sourceTexture.baseTexture.resolution
        });
        StageManager.renderer.render(sprite, renderTexture);

        const id:string = sourceTexture.textureCacheIds[0] + ColorEffectTextureCache.SUFFIX_WHITE;
        if(PIXI.utils.TextureCache[id]) {
            PIXI.utils.TextureCache[id] = renderTexture;
        } else {
            PIXI.Texture.addToCache(renderTexture, id);
        }

    }

    private static createDesaturatedTexture(sourceTexture:PIXI.Texture, desaturateAmount:number) {
        const sprite = new PIXI.Sprite(sourceTexture);
        const colorMatrixFilter = new PIXI.filters.ColorMatrixFilter();
        colorMatrixFilter.saturate(-desaturateAmount, false);
        sprite.filters = [colorMatrixFilter];
        const renderTexture:PIXI.RenderTexture = PIXI.RenderTexture.create({
            width : sourceTexture.width,
            height : sourceTexture.height,
            scaleMode : sourceTexture.baseTexture.scaleMode,
            resolution : sourceTexture.baseTexture.resolution
        });
        StageManager.renderer.render(sprite, renderTexture);

        const id:string = sourceTexture.textureCacheIds[0] + ColorEffectTextureCache.SUFFIX_DESATURATED + desaturateAmount;
        if(PIXI.utils.TextureCache[id]) {
            PIXI.utils.TextureCache[id] = renderTexture;
        } else {
            PIXI.Texture.addToCache(renderTexture, id);
        }
    }
}